// extracted by mini-css-extract-plugin
export var active = "_3s-7";
export var container = "_3s-0";
export var evenWidth = "_3s-4";
export var large = "_3s-5";
export var outlet = "_3s-8";
export var slide = "_3s-2";
export var small = "_3s-6";
export var tab = "_3s-3";
export var tabs = "_3s-1";